import styled from 'styled-components';

const CenteredDiv = styled('div')`
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;

export default CenteredDiv;
